import React from 'react';
import { Container, Row } from 'react-bootstrap';

import PageTitle from '../../components/common/PageTitle';
import TeamForm from '../../components/team/TeamForm';

function Team({ t }) {
  return (
    <Container className="main-content-container p-3 p-md-5 d-flex flex-column flex-grow-1">
      <Row className="g-0 page-header mb-3 mb-md-5">
        <PageTitle title={t('settings.account.title')} backBtn />
      </Row>

      <TeamForm />
    </Container>
  );
}

export default Team;
